'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useRef } from 'react';

import { mergeRefs } from '@madeinhaus/utils';
import cx from 'clsx';
import PropTypes from 'prop-types';

import ButtonCTA from 'components/ui/ButtonCTA';
import Img from 'components/ui/Img';

import useScrollProgress from 'hooks/useScrollProgress';

import styles from './Hero.module.scss';

const PRODUCT_MOBILE =
    'https://images.ctfassets.net/j8tkpy1gjhi5/11ZLM3p0UMAF7QE7QeZ60p/de2c616047c0cbd372f6e3e6c098caa7/mobile-product-r1.png';

const LEFT_HAND_DESKTOP =
    'https://images.ctfassets.net/j8tkpy1gjhi5/dKuLPvxuIbOb1n2wpXePR/f3b9bb03ec5d466014d1cf443bee555b/hand.png';

const CHEESE_MOBILE =
    'https://images.ctfassets.net/j8tkpy1gjhi5/1YQsNcSjLQu7wdhMjVPKaQ/db14ae3e67d5554d14fafa73ffafe6f4/mobile-cheese-r1.png';

const CHEESE_DESKTOP =
    'https://images.ctfassets.net/j8tkpy1gjhi5/6WLUsVYnJo0fJoETVeCKI9/673ccc3e8f8d0d0878cb3e65f6aba5b8/cheese.png';

const HAND_MOBILE =
    'https://images.ctfassets.net/j8tkpy1gjhi5/1hdIGZfnSH7bBBz4bBzCca/300cff03b9fef3cb65be3a3ae21cf4df/mobile-hand-r1.png';

const RIGHT_HAND_DESKTOP =
    'https://images.ctfassets.net/j8tkpy1gjhi5/4oXihGfToRT2joxwR0sWgi/d0be311bac8446d10adf48df37a75fe5/slice_pack.png';

const Hero = ({ showIntro }) => {
    const titleRef = useRef(null);
    const buttonRef = useRef(null);

    const { setSection, setNode } = useScrollProgress({
        windowHeightBehavior: 'ignore',
        callback: progress => {
            const dist = `${progress * 12}vw`;
            titleRef.current?.style.setProperty(
                'transform',
                `translate3d(0, ${dist}, 0)`
            );
            buttonRef.current?.style.setProperty(
                'transform',
                `translate3d(0, ${dist}, 0)`
            );
        },
    });

    return (
        <div className={cx(styles.root)}>
            <div className={styles.hero} ref={setSection}>
                <div className={styles.inner}>
                    <div className={styles.headingGroup}>
                        <h1
                            className={styles.title}
                            ref={mergeRefs([setNode, titleRef])}
                        >
                            EXTRAORDINARY{' '}
                            <span className={styles.titleMark}>
                                DAIRY<sup>&reg;</sup>
                            </span>
                        </h1>
                        <ButtonCTA
                            ref={buttonRef}
                            className={styles.cta}
                            text={`Melty mood lift`}
                            style="filled-blue-ocean"
                            link={{ slug: 'recipes' }}
                        />
                        <div
                            className={cx(styles.heroImage, {
                                [styles.showIntro]: showIntro,
                            })}
                        >
                            <div>
                                <Img
                                    className={styles.cheese}
                                    src={CHEESE_MOBILE}
                                    fallbackImageWidth={768}
                                    alt={'Stack of Tillamook products.'}
                                    priority
                                    customSources={[
                                        {
                                            breakpoint: 1280,
                                            src: CHEESE_DESKTOP,
                                            imageWidth: 2500,
                                        },
                                        {
                                            breakpoint: 768,
                                            src: CHEESE_DESKTOP,
                                            imageWidth: 1920,
                                        },
                                        {
                                            src: CHEESE_MOBILE,
                                            imageWidth: 1280,
                                        },
                                    ]}
                                />

                                <Img
                                    className={styles.rightHand}
                                    src={HAND_MOBILE}
                                    fallbackImageWidth={768}
                                    alt={'Stack of Tillamook products.'}
                                    priority
                                    customSources={[
                                        {
                                            breakpoint: 1280,
                                            src: RIGHT_HAND_DESKTOP,
                                            imageWidth: 2500,
                                        },
                                        {
                                            breakpoint: 768,
                                            src: RIGHT_HAND_DESKTOP,
                                            imageWidth: 1920,
                                        },
                                        {
                                            src: HAND_MOBILE,
                                            imageWidth: 1280,
                                        },
                                    ]}
                                />
                                <Img
                                    className={styles.leftHand}
                                    src={PRODUCT_MOBILE}
                                    fallbackImageWidth={768}
                                    alt={'Stack of Tillamook products.'}
                                    priority
                                    customSources={[
                                        {
                                            breakpoint: 1280,
                                            src: LEFT_HAND_DESKTOP,
                                            imageWidth: 2500,
                                        },
                                        {
                                            breakpoint: 768,
                                            src: LEFT_HAND_DESKTOP,
                                            imageWidth: 1920,
                                        },
                                        {
                                            src: PRODUCT_MOBILE,
                                            imageWidth: 1280,
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Hero.propTypes = {
    productNavigation: PropTypes.shape({
        navItemsCollection: PropTypes.shape({
            items: PropTypes.array.isRequired,
        }),
    }),
    showIntro: PropTypes.bool,
};

export default Hero;
